// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"3ec1b508","711":"9facfa0c"}[chunkId] + ".chunk.js";
};